import classes from "./ActivityEditor.module.css";
import YuJaButton from "../../components/standardization/YuJaButton";
import {
    ACTIVITY_EDITOR_VIEW,
    BACK_TEXT,
    CONTINUE_TEXT,  GRADE_SCHEMA, IMPORT_QUESTIONS_TEXT,
    INTEGRATION_TYPES, MODAL_CANCEL_TEXT,
    MODAL_NEXT_TEXT, QUESTION_TYPES, USER_SETTINGS,
} from "../../utils/constants";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import React, {Fragment, useState} from "react";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {ReactComponent as COMPLETED} from "./images/workflow_step_completed.svg";
import {ReactComponent as GRADE_BOOK_ICON} from "../../images/links/active_gradebook_icon.svg";
import {ReactComponent as IMPORTING_CSV} from "./images/importing_csv_workflow_img.svg";
import {ReactComponent as IMPORTING_QUESTION_BANK} from "./images/importing_question_bank_workflow_img.svg";
import {ReactComponent as IMPORTING_CANVAS} from "./images/importing_canvas_workflow_img.svg";
import {ReactComponent as IMPORTING_BLACKBOARD} from "./images/importing_blackboard_workflow_img.svg";
import {ReactComponent as IMPORTING_D2L} from "./images/importing_d2l_workflow_img.svg";
import {ReactComponent as IMPORTING_MOODLE} from "./images/importing_moodle_workflow_img.svg";
import {Button} from "@base-ui/react/button";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import ImportQuestionsCSV from "./ImportQuestionsCSV";
import {
    getQuestionWeightage,
    notifySuccess
} from "../../utils/helpers";
import ImportQuestionsQuestionBank from "./ImportQuestionsQuestionBank";
import YuJaDialog from "../../components/standardization/YuJaDialog";
import ImportQuestionsCanvas from "./ImportQuestionsCanvas";
import {WORKFLOW_OBJ} from "./ActivityEditorImportQuestions";
import dialogClasses from "../../components/standardization/YuJaDialog.module.css";
import ImportQuestionsBlackboard from "./ImportQuestionsBlackboard";


export default function ActivityEditorImportQuestionsModal({
                                                          parentRef,
                                                          open=false,
                                                          setEditorView,
                                                          draftActivity,
                                                          setDraftActivity,
                                                          courseList=[],
                                                          questionBankId,
                                                          userSettings={},
                                                      }) {
    const {width: windowWidth, height: windowHeight} = useWindowDimensions();
    const [setPreviousView, getPreviousView] = useLocalStorageNew("previous_editor_view", "");
    const {getIntegrationType} = useSynLMSConfiguration();
    const [importedQuestions, setImportedQuestions] = useState([]);
    const [isImporting, setIsImporting] = useState(false);
    const [isSelectedImportItem, setIsSelectedImportItem] = useState(false);
    const [removePointsConfirmationShown, setRemovePointsConfirmationShown] = useState(false);




    const copyWorkflows = (workflows) => {
        const copy = [];
        for (const workflow of workflows) {
            const raw = WORKFLOW_OBJ[workflow.key];
            let copyWorkflow = JSON.parse(JSON.stringify(workflow));
            copyWorkflow.img = raw.img;
            for (let i = 0; i < copyWorkflow.steps.length; i++) {
                let step = copyWorkflow.steps[i];
                let rawStep = raw.steps[i];
                step.icon = rawStep.icon;
            }
            copy.push(copyWorkflow);
        }

        return copy;
    }

    const [workflows, setWorkflows] = useState(() => {
        const integrationType = getIntegrationType();
        let res = [];
        if (integrationType === INTEGRATION_TYPES.CANVAS) {//it's Canvas LTI
            res.push(WORKFLOW_OBJ.CANVAS_WORKFLOW);
        } else if (integrationType === INTEGRATION_TYPES.BLACKBOARD) {
            res.push(WORKFLOW_OBJ.BLACKBOARD_WORKFLOW);
        }
        res.push(WORKFLOW_OBJ.CSV_WORKFLOW);
        res.push(WORKFLOW_OBJ.QUESTION_BANK_WORKFLOW);

        res = copyWorkflows(res)


        res[0].steps[0].active = true;
        return res;
    });

    const [selectedWorkflow, setSelectedWorkflow] = useState(workflows[0]);

    const onClose = () => {
        let previousView = getPreviousView();
        setPreviousView("");
        setEditorView(!previousView ? ACTIVITY_EDITOR_VIEW.QUESTION_EDITING : previousView);
    }

    const onSelectImportMethod = (workflowKey) => {
        let selected = {};
        for (const workflow of workflows) {
            for (let step of workflow.steps) {
                step.active = false;
                step.completed = false;
            }

            if (workflow.key === workflowKey) {
                workflow.steps[0].active = true;
                selected = workflow;
            }
        }

        setSelectedWorkflow(selected);
    }

    const onBack = () => {
        let activeStep = selectedWorkflow.steps.find(s => !!s.active);
        if (activeStep.isFirst) {
            setEditorView(ACTIVITY_EDITOR_VIEW.QUESTION_EDITING);
            return;
        }


        let key = selectedWorkflow.key;
        let copy = copyWorkflows(workflows);
        let copySelected = copy.find(w => w.key === key);
        let selectedIdx = 0;
        for (let i = 0; i < copySelected.steps.length; i++) {
            let step = copySelected.steps[i];
            if (step.active) {
                selectedIdx = i;
                step.active = false;
                step.completed = false;
            }
        }
        let backStep = copySelected.steps[selectedIdx - 1];
        backStep.active = true;
        backStep.completed = false;

        if (backStep.isFirst) {//clean the flag
            setIsSelectedImportItem(false);
        }


        setWorkflows(copy);
        setSelectedWorkflow(copySelected);
    }

    const isNextDisabled = () => {
        let activeStep = selectedWorkflow.steps.find(s => !!s.active);
        if (activeStep.isLast) {//last step: import question
            return importedQuestions.length === 0;
        } else if (activeStep.isFirst) {//first step
            return false;
        } else {//mid step
            return !isSelectedImportItem;
        }
    }


    const onImport = () => {
        let activityCopy = JSON.parse(JSON.stringify(draftActivity));
        let questionsCopy = activityCopy.questions;
        const size = questionsCopy.length;
        const lastQ = size ? questionsCopy[size - 1] : {};
        if (!lastQ.questionType && !!importedQuestions.length) {
            questionsCopy.pop();
        }
        let curr_questions = questionsCopy;
        importedQuestions.forEach((item) => {
            item.serialNo = curr_questions.length + 1;
            if (draftActivity.gradeSchema === GRADE_SCHEMA.UNGRADED.key) {
                item.weightage = 0;
                item.participationWeightage = 0;
            }
            if (item.questionType === QUESTION_TYPES.WC.name && !item.entries) {
                item.entries = userSettings[USER_SETTINGS.QUESTION_ENTRIES];
            }
            item.timeLimit = userSettings[USER_SETTINGS.QUESTION_DURATION];
            item.getReadyTimeLimit = userSettings[USER_SETTINGS.QUESTION_COUNTDOWN];
            item.classResultDuration = userSettings[USER_SETTINGS.QUESTION_CLASS_RESULT_DURATION];

            curr_questions.push(item);
        });
        activityCopy.questions = curr_questions;
        setDraftActivity(activityCopy);
        setIsImporting(true);
        setTimeout(() => {
            notifySuccess("Questions have been successfully imported.");
            onClose();
            setIsImporting(false);
        }, 2000);


    }

    const onNext = () => {
        let key = selectedWorkflow.key;
        let copy = copyWorkflows(workflows);
        let copySelected = copy.find(w => w.key === key);
        let activeStep = copySelected.steps.find(s => !!s.active);

        if (activeStep.isLast) {
            let totalPoints = importedQuestions.reduce(function (result, q) {
                return result + getQuestionWeightage(q);
            }, 0);

            if (draftActivity.gradeSchema === GRADE_SCHEMA.UNGRADED.key && totalPoints > 0) {
                setRemovePointsConfirmationShown(true);
            } else {
                onImport();
            }
        } else {
            let selectedIdx = 0;
            for (let i = 0; i < copySelected.steps.length; i++) {
                let step = copySelected.steps[i];
                if (step.active) {
                    selectedIdx = i;
                    step.active = false;
                    step.completed = true;
                }
            }

            copySelected.steps[selectedIdx + 1].active = true;
            setWorkflows(copy);
            setSelectedWorkflow(copySelected);
        }

        // setIsImporting(true);

    }

    const renderWorkFlow = () => {
        return (
            <div className={classes.workflowContainer} style={{gap: 15}}>
                {selectedWorkflow.steps.map((step, index) => {
                    let ICON = step.icon;
                    if (step.completed) {
                        ICON = COMPLETED;
                    }

                    let isLabelHidden;

                    if (windowWidth < 700) {
                        isLabelHidden = true;
                    } else if (windowWidth > 900 || step.active) {
                        isLabelHidden = false;
                    } else {
                        isLabelHidden = true;
                    }

                    return (
                        <Fragment key={index}>
                            {index !== 0 &&
                                <div className={classes.workflowConnector}/>
                            }
                            <div
                                className={`${classes.workflowLabel} ${step.active ? classes.active : ""} ${step.completed ? classes.completed : ""}`}
                            >
                                <YuJaTooltip disabled={!isLabelHidden} text={step.label} disableTab={true}>
                                   <ICON/>
                                </YuJaTooltip>
                                {!isLabelHidden && <div>{step.label}</div>}
                            </div>
                        </Fragment>
                    );
                })}
            </div>
        );
    }

    const renderChooseImportMethod = () => {
        return (
            <div className={classes.importQuestionBody} style={{padding: 30}}>
                <div style={{height: 45, flexShrink: 1}}/>
                <div style={{alignSelf: "center", display: "flex", gap: 15, alignItems: "center"}}>
                    <div className={classes.plusIconWrapper}><GRADE_BOOK_ICON/></div>
                    <h3 className={classes.title}>{"How would you like to import questions to this poll?"}</h3>
                </div>
                <div style={{height: 35, minHeight: 15, flexShrink: 1}}/>
                <div className={classes.row} style={{gap: 15, flexDirection: windowWidth > 900 ? undefined : 'column'}}>
                    {workflows.map((item, index) => {
                        let IMG = item.img;
                        return (
                            <Button
                                key={index}
                                className={`
                                    ${classes.gradeSchemaCard} 
                                    ${selectedWorkflow.key === item.key ? classes.active : ""}
                                `}
                                style={{minWidth: 250, maxWidth: 400, width: '100%'}}
                                onClick={() => onSelectImportMethod(item.key)}
                            >
                                <IMG style={{marginBottom: 15, flexShrink: 0}}/>
                                <span className={classes.title} style={{whiteSpace: "nowrap"}}>{item.title}</span>
                                <span className={classes.description} style={{textAlign: "center"}}>
                                    {item.description}
                                </span>

                            </Button>
                        );
                    })}

                </div>
                <div style={{flex: 1, minHeight: 20}}/>
            </div>
        );
    }


    if (isImporting) {
        return (
            <div
                className={`${classes.parentContainer} ${classes.column}`}
                style={{padding: 20, alignItems: "center"}}
            >
                <div style={{flex: 1}}/>
                {selectedWorkflow.key === WORKFLOW_OBJ.CANVAS_WORKFLOW.key &&
                    <IMPORTING_CANVAS/>
                }

                {selectedWorkflow.key === WORKFLOW_OBJ.BLACKBOARD_WORKFLOW.key &&
                    <IMPORTING_BLACKBOARD/>
                }

                {selectedWorkflow.key === WORKFLOW_OBJ.D2L_WORKFLOW.key &&
                    <IMPORTING_D2L/>
                }

                {selectedWorkflow.key === WORKFLOW_OBJ.MOODLE_WORKFLOW.key &&
                    <IMPORTING_MOODLE/>
                }

                {selectedWorkflow.key === WORKFLOW_OBJ.CSV_WORKFLOW.key &&
                    <IMPORTING_CSV/>
                }

                {selectedWorkflow.key === WORKFLOW_OBJ.QUESTION_BANK_WORKFLOW.key &&
                    <IMPORTING_QUESTION_BANK/>
                }

                <h3 className={classes.importingTitle}>
                    {"Importing Questions"}
                </h3>

                <div className={classes.importingDescription}>
                    {"Please wait while we are importing questions to Engage..."}
                </div>
                <div style={{flex: 2, minHeight: 80}}/>
            </div>
        );
    }



    return (
        <>
            <div className={`${classes.parentContainer} ${classes.column}`} style={{overflowY: "auto", padding: 0}}>
                <div className={classes.importQuestionCard} style={{border: "none", boxShadow: "none"}} >
                    <div className={classes.importQuestionHeader}>
                        {renderWorkFlow()}
                    </div>

                    {selectedWorkflow.steps.find(s => !!s.active).isFirst &&
                        renderChooseImportMethod()
                    }
                    {!selectedWorkflow.steps.find(s => !!s.active).isFirst
                        && selectedWorkflow.key === WORKFLOW_OBJ.CSV_WORKFLOW.key
                        &&
                        <div className={classes.importQuestionBody} style={{padding: 30}}>
                            <ImportQuestionsCSV
                                draftActivity={draftActivity}
                                userSettings={userSettings}
                                gradeSchema={draftActivity.gradeSchema}
                                setImportedQuestions={setImportedQuestions}
                            />

                        </div>
                    }

                    {!selectedWorkflow.steps.find(s => !!s.active).isFirst
                        && selectedWorkflow.key === WORKFLOW_OBJ.QUESTION_BANK_WORKFLOW.key
                        &&
                        <div className={classes.importQuestionBody} style={{padding: 30}}>
                            <ImportQuestionsQuestionBank
                                draftActivity={draftActivity}
                                userSettings={userSettings}
                                importedQuestions={importedQuestions}
                                setImportedQuestions={setImportedQuestions}
                                selectedWorkflow={selectedWorkflow}
                                setIsSelectedImportItem={setIsSelectedImportItem}
                            />
                        </div>
                    }

                    {!selectedWorkflow.steps.find(s => !!s.active).isFirst
                        && selectedWorkflow.key === WORKFLOW_OBJ.CANVAS_WORKFLOW.key
                        &&
                        <div className={classes.importQuestionBody}>
                            <ImportQuestionsCanvas
                                courseList={courseList}
                                draftActivity={draftActivity}
                                userSettings={userSettings}
                                importedQuestions={importedQuestions}
                                setImportedQuestions={setImportedQuestions}
                                selectedWorkflow={selectedWorkflow}
                                setIsSelectedImportItem={setIsSelectedImportItem}
                            />
                        </div>
                    }

                    {!selectedWorkflow.steps.find(s => !!s.active).isFirst
                        && selectedWorkflow.key === WORKFLOW_OBJ.BLACKBOARD_WORKFLOW.key
                        &&
                        <div className={classes.importQuestionBody}>
                            <ImportQuestionsBlackboard
                                courseList={courseList}
                                draftActivity={draftActivity}
                                userSettings={userSettings}
                                importedQuestions={importedQuestions}
                                setImportedQuestions={setImportedQuestions}
                                selectedWorkflow={selectedWorkflow}
                                setIsSelectedImportItem={setIsSelectedImportItem}
                            />
                        </div>
                    }
                </div>

                <YuJaDialog
                    open={removePointsConfirmationShown}
                    setOpen={setRemovePointsConfirmationShown}
                    title={"Ungraded Poll"}
                    centerAligned={false}
                    submitText={CONTINUE_TEXT}
                    onSubmit={onImport}
                    closeText={MODAL_CANCEL_TEXT}
                >
                    <div style={{color: "#6B6B6B", margin: 0, whiteSpace: "pre-line"}}>
                        {"All questions points are going to be removed. Are you sure you want to import those questions?"}
                    </div>
                </YuJaDialog>

            </div>
            <div className={dialogClasses.Actions} style={{justifyContent: "space-between", padding: "15px 30px"}}>
                <YuJaButton
                    size={"small"}
                    style={{minWidth: 120}}
                    onClick={() => onBack()}
                >
                    {BACK_TEXT}
                </YuJaButton>


                <YuJaButton
                    disabled={isNextDisabled()}
                    isLoading={isImporting}
                    style={{minWidth: 120}}
                    size={"small"}
                    onClick={() => onNext()}
                >
                    {selectedWorkflow.steps.find(s => !!s.active).isLast ? IMPORT_QUESTIONS_TEXT :  MODAL_NEXT_TEXT}
                </YuJaButton>
            </div>
        </>

    );
}



